import { render, staticRenderFns } from "./NavBorder.vue?vue&type=template&id=648b0b80&"
import script from "./NavBorder.vue?vue&type=script&lang=js&"
export * from "./NavBorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports